import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '@sabstravtech/obtservices/angular';

import { LightningUserFavorurite } from '../../../core/classes/user-favourite.enum';
import { ThemeService } from '../../../core/services/theme.service';

@Component({
  selector: 'app-ndc-fare-link',
  templateUrl: './ndc-fare-link.component.html',
  styleUrls: ['./ndc-fare-link.component.scss'],
  standalone: false
})
export class NdcFareLinkComponent implements OnInit {
  @Input() serviceName: string;
  @Input() additionalClass = '';

  ndcFareInfoUrl = 'https://uk.travelctm.com/ndc/';
  hideNdcUrl = false;

  constructor(
    private userService: UserService,
    private themeService: ThemeService
  ) {}

  ngOnInit(): void {
    const flightConfig = this.userService.getUserFavoriteObject<{
      NDC?: { ndcFareInfoUrl?: string; hideUrl?: boolean };
    }>(LightningUserFavorurite.FlightResultsConfiguration);
    if (flightConfig?.NDC?.ndcFareInfoUrl) {
      this.ndcFareInfoUrl = flightConfig.NDC.ndcFareInfoUrl;
    }
    if (flightConfig?.NDC?.hideUrl && !this.themeService.isLightningEnv) {
      this.hideNdcUrl = true;
    }
  }
}
